import { SEO } from '../../components';
import {
  Header,
  Footer,
  HeroSection,
  FinalCTASection,
} from '../../components/sections';
import {
  UiUxDesignProcessSection,
  UiUxBlogPromoSection,
  UiUxCollaborationSection,
} from '../../components/sections/services';
import { getCanonicalUrl, buildHreflangTags } from '../../lib/siteUrl';

export default function UiUxDesignPage() {
  return (
    <>
      <SEO
        title="UI/UX Design | Identio"
        description="UX design engages users and creates high-level digital experiences. Comprehensive design skills—from user research and wireframes to UI design and testing."
        url={getCanonicalUrl('/services/ui-ux-design')}
        alternates={buildHreflangTags('/palvelut/ui-ux-suunnittelu', '/services/ui-ux-design')}
      />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection variant="uiUxDesign" />
        <UiUxDesignProcessSection />
        <UiUxBlogPromoSection />
        <UiUxCollaborationSection />
        <FinalCTASection
          variant="withForm"
          showContactSidebar={true}
          title="Need UI/UX expertise?"
          subtitle="Let's discuss how user research, wireframes, and interface design can improve your product and user experience."
        />
      </main>
      <Footer />
    </>
  );
}
